<template>
    <div>
        <router-view />
    </div>
</template>

<script lang="ts" setup>
</script>
